import React, { useEffect } from "react";
import Header from "../../../components/header";
import "./wellbing.css";
import HomeVideo from "../../../assets/support_background.webp";
import { ParallaxProvider } from "react-scroll-parallax";
import Healthcare from "./healthcare-part";
import Community from "./community-part";
import FlipCard from './FlipCard'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

export default function Wellbing() {

  const handleScrollToNext = () => {
    const nextSection = document.getElementById("healthcare");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ParallaxProvider>
      <div className="screen-page">
        <Header />
        {/* section 01 */}
        {/* home video */}
        <div style={{ position: "relative" }}>
          <div className="home-page-video">
            <div>
              <img
                src={HomeVideo}
                style={{ height: "calc(100vh - 120px)", width: "100%", objectFit: "cover" }}
                alt=""
              />
              {/* <video
              autoPlay
              loop
              muted
              className="home-video"
              style={{ height: "100vh", width: "100%", objectFit: "cover" }}
            >
              <source src={HomeVideo} type="video/mp4" />
            </video> */}
            </div>
          </div>

          {/* <div style={{ marginLeft: "20px" }}>
            <div className="wellbing-text-box">
              <div>
                <Parallax speed={10}>
                  <h1 className="wellbing-topic-home">WELLBEING</h1>
                </Parallax>
              </div>
            </div>
          </div> */}

          {/* White Box */}
          <div className="white-box">
            <div className="white-box-container">
              {/* <h1>
                Modern <span className="white-box-container-h1">& Unique</span>
              </h1> */}
              <div className="screen-pc">
                <h1 className="white-box-container-h1-text">
                  {/* Conserve <br /> */}
                  <span className="white-box-container-h1">Wellbeing</span>
                </h1>
              </div>

              <div className="screen-mobile">
                <p className="white-box-container-h1-text">
                {/* Conserve <br /> */}
                  <span className="white-box-container-h1">
                  Wellbeing <br />
                  </span>
                </p>
              </div>

              {/* Button to scroll to the next section */}
              <div onClick={handleScrollToNext} className="scroll-button">
                <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: "16px" }} />
              </div>
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "calc(100vh - 120px)",
              backgroundColor: "rgba(0, 0, 0, 0.15)",
              zIndex: 0,
            }}
          ></div>

          {/* H Letter Design */}
          <div className="h-banner-container">
            {/* Left Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-left"></div>
            </div>

            {/* Middle Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-design-N">
                <div className="h-left-N"></div>
                <div style={{ height: "350px" }} />
                <div className="h-right-N"></div>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-right"></div>
            </div>
          </div>
        </div>

        {/* section-2 */}
        <Healthcare />

        {/* section-3 */}
        <Community />

        {/* Section - 4 */}
        <FlipCard />
      </div>
    </ParallaxProvider>
  );
}
